import React from "react";
import { Input, Form, Col } from "antd";
import { InputProps } from "antd/lib/input";
import ConfigComponent from "../config components/config.Components";
import BaseProps from "../BaseProps/baseProps";
import { FormItemC } from "..";

export interface InputComponentProps extends InputProps, BaseProps {}

const InputComponent = (props: InputComponentProps) => {
  const { input: inputDef } = ConfigComponent;
  const { inCol: inColDef, inForm: inFormDef, col: colDef } = inputDef;
  /* --------------------------------- Default -------------------------------- */
  const {
    inForm = inFormDef,
    formItem,
    inCol = inColDef,
    col,
    ...antdProps
  } = props;

  const component = <Input {...inputDef} {...antdProps} />;
  if (inForm && !inCol) {
    return <FormItemC {...(formItem as any)}>{component}</FormItemC>;
  }

  if (inCol && !inForm) {
    return <Col {...col}>{component}</Col>;
  }
  if (inCol && inForm) {
    return (
      <Col {...col}>
        <FormItemC {...(formItem as any)}>{component}</FormItemC>
      </Col>
    );
  }
  return component;
};

export default InputComponent;
